module.exports = function getResource(label, vars = []) {
    let resources = {
        userLabelText: `You must be ${vars[0]} to access this product.`,
        signIn: 'Sign in',
        or: 'or',
        signUp: 'Sign up',
        learnMore: 'Learn more',
        download: 'Download',
        openApp: 'open the Sephora app to purchase'
    };
    return resources[label];
};
